import { getStatusConfig, formatDateTime } from '@/lib/report-helpers';
import { cn } from '@/lib/utils';

interface TimelineEntry {
  status?: string;
  note?: string | null;
  createdAt?: string;
}

/**
 * Vertical status timeline — reused on the public tracking page and later
 * by the staff workspace.
 */
export function StatusTimeline({ entries }: { entries: TimelineEntry[] }) {
  if (!entries || entries.length === 0) {
    return <p className="text-sm text-muted-foreground">No status updates yet.</p>;
  }

  return (
    <ol className="relative ml-3 space-y-5 border-l border-border">
      {entries.map((entry, i) => {
        const cfg = getStatusConfig(entry.status);
        const isLatest = i === entries.length - 1;
        return (
          <li key={i} className="ml-6">
            <span
              className={cn(
                'absolute -left-[7px] mt-1 h-3 w-3 rounded-full ring-2 ring-background',
                cfg.dotClass,
                isLatest && 'animate-pulse'
              )}
            />
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-medium">{cfg.label}</span>
              <span className="text-xs text-muted-foreground">
                {formatDateTime(entry.createdAt)}
              </span>
            </div>
            {entry.note && (
              <p className="mt-1 text-sm text-muted-foreground">{entry.note}</p>
            )}
          </li>
        );
      })}
    </ol>
  );
}
